/**
 * @file  Unsubscribe
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */


import React, {useEffect, useContext} from 'react';
import {Form, Input, Button, message, Divider} from 'antd';
import {useHistory} from 'react-router-dom';
import Iconfont from '~/component/Iconfont';
import {unsubscribe} from '~/service/subscription';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

function Unsubscribe() {
    const history = useHistory();
    const [form] = Form.useForm();
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    async function onCheck() {
        const params = await form.validateFields();
        unsubscribe(params)
            .then(({data}) => {
                if (data) {
                    message.success('Success');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
                else {
                    message.error(`Unable to unsubscribe ${params.email}`);
                }
            })
            .catch(msg => {
                message.error(msg);
            });
    }

    function handleBack() {
        history.push('/contact/investor');
    }

    return (
        <div className="unsubscribe-content">
            {
                !isMobile && (
                    <div
                        className="unsubscribe-back"
                        onClick={handleBack}
                        role="button"
                        tabIndex={0}
                    >
                        <Iconfont type="iconmianbaoxiexiayiji" className="iconmianbaoxiexiayiji" />
                        <span className="unsubscribe-back-btn">Back</span>
                    </div>
                )
            }

            {
                isMobile && (
                    <>
                        <div className="unsubscribe-content-title">
                            Investor Alerts
                        </div>
                        <Divider />
                    </>
                )
            }


            <div className="unsubscribe-title">
                Enter the email address that you used to subscribe to this list.
            </div>

            <Form
                layout="vertical"
                form={form}
            >
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required'
                        },
                        {
                            type: 'email',
                            max: 100,
                            message: 'Please input a valid email address'
                        }
                    ]}
                >
                    <Input autoComplete="off" />
                </Form.Item>

                <Form.Item>
                    <Button
                        className={isMobile ? 'form-btn' : ''}
                        type={isMobile ? 'text' : 'primary'}
                        onClick={onCheck}
                    >
                        Unsubscribe
                    </Button>
                </Form.Item>
            </Form>


        </div>
    );
}

export default Unsubscribe;
